<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ item.SessionCode }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, SESSION_STATUS)}">{{ item.Status | display_value(SESSION_STATUS) }}</td>
                <td class="text-right">{{ item.TotalPackage | currency }}</td>
                <td class="text-right">{{ item.TotalWeight | currency('', 1) }}</td>
                <td class="text-right">{{ item.TotalVolume | currency('', 2) }}</td>
                <td>{{ item.Note }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)" :disabled="item.Status == 2">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Mã phiên",
          value: "SessionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.SESSION_STATUS,
          dataType: dataType["Enum"],
        },
        {
          text: "Số kiện",
          value: "TotalPackage",
          filterable: true,
          align: "end",
          dataType: dataType["Number"],
        },
        {
          text: "Số cân",
          value: "TotalWeight",
          filterable: true,
          align: "end",
          dataType: dataType["Number"],
        },
        {
          text: "Số khối",
          value: "TotalVolume",
          filterable: true,
          align: "end",
          dataType: dataType["Number"],
        },
        {
          text: "Ghi chú",
          value: "Note",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      SESSION_STATUS: configs.SESSION_STATUS,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "sessions_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
      get_status_color: this.$options.filters.display_color
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: mapState({
    items: (state) => state.sessions.all.data,
    total_rows: (state) => state.sessions.all.total,
    loading: (state) => state.sessions.loading
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("sessions/getList", param);
    },
    gotoDetail: function (id) {
      this.$router.push({
        name: "SessionDetail",
        params: {
          Pid: id,
          title: `Chi tiết phiên làm việc (#${id})`,
        },
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "SessionDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới phiên làm việc`,
        },
      });
    }
  },
  mounted() {
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("prices/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
